// src/components/HowToSellSection.js
import React from 'react';

const steps = [
  {
    icon: '/project/images/call-img.png',
    alt: 'Call',
    title: 'Contact Us:',
    desc: 'Call us at 021747792 or fill out the online form.'
  },
  {
    icon: '/project/images/massage.png',
    alt: 'Quote',
    title: 'Get Your Quote:',
    desc: 'We’ll assess your car’s condition and offer the best cash price.'
  },
  {
    icon: '/project/images/truck.png',
    alt: 'Pickup',
    title: 'Schedule Pickup:',
    desc: 'Arrange a convenient time for us to remove your car at no extra cost.'
  },
  {
    icon: '/project/images/money-a.png',
    alt: 'Payment',
    title: 'Get Paid:',
    desc: 'Receive your payment in cash, and we’ll take care of the paperwork.'
  }
];

const HowToSellSection = () => (
  <section className="how-sell-section pt-6 pb-6">
    <div className="container">
      <div className="row">
        {/* Left Column */}
        <div className="col-lg-6 mb-4 mb-lg-0">
          <div className="how-box">
            <h3><strong>HOW IT WORKS</strong></h3>
            <ul className="list-unstyled mt-4 how-sell-box">
              {steps.map((step, i) => (
                <li key={i} className="d-flex align-items-start mb-3">
                  <img src={step.icon} alt={step.alt} className="me-3" width="30" />
                  <p>
                    <strong>{step.title}</strong> {step.desc}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-lg-6">
          <div className="form-box">
            <h3><strong>Sell Your Car</strong></h3>
            <form className="mt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <input type="text" className="form-control" placeholder="Name" required />
                </div>
                <div className="col-md-6">
                  <input type="text" className="form-control" placeholder="Phone No." required />
                </div>
                <div className="col-md-6">
                  <input type="email" className="form-control" placeholder="Email" required />
                </div>
                <div className="col-md-6">
                  <input type="text" className="form-control" placeholder="Pickup Location" required />
                </div>
                <div className="col-12">
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Tell Us About Your Vehicle"
                  ></textarea>
                </div>
                <div className="col-12 text-center">
                  <button type="submit" className="btn btn-success px-4">
                    Get An Offer
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HowToSellSection;
